<h1 class="ms-2 mt-2">Availability and creation Tester</h1>

<h2 class="mt-4 ms-2">Prompt API</h2>

<div class="d-flex gap-3">
  <div class="card flex-fill">
    <div class="card-body">
      <h3>Availability</h3>

      @if (this.promptError) {
        <div class="alert alert-danger">{{ this.promptError }}</div>
      }

      <div class="">
        <div>Status:</div>
        <span
          class="badge text-bg-secondary"
          [class.text-bg-secondary]="this.promptAvailability === 'downloadable'"
          [class.text-bg-danger]="this.promptAvailability === 'unavailable'"
          [class.text-bg-success]="this.promptAvailability === 'available'"
          [class.text-bg-primary]="this.promptAvailability === 'downloading'">{{ this.promptAvailability }}</span>
      </div>

      <div class="d-grid mt-5">
        <button class="btn btn-primary" (click)="checkPromptAvailability()">Check availability</button>
      </div>
    </div>
  </div>

  <div class="card flex-fill">
    <div class="card-body">
      <h3>Creation</h3>

      @if (this.promptCreationError) {
        <div class="alert alert-danger">{{ this.promptCreationError }}</div>
      }

      <div class="">
        <div>Status:</div>
        <span
          class="badge text-bg-secondary"
          [class.text-bg-secondary]="this.promptCreationSuccess === undefined"
          [class.text-bg-danger]="this.promptCreationSuccess === false"
          [class.text-bg-success]="this.promptCreationSuccess === true">{{ this.promptCreationSuccess }}</span>
      </div>

      <div class="d-grid mt-5">
        <button class="btn btn-primary" (click)="createPrompt()">Create</button>
      </div>
    </div>
  </div>
</div>


<hr>

<h2 class="mt-4 ms-2">Proofreader</h2>

<div class="d-flex gap-3">
  <div class="card flex-fill">
    <div class="card-body">
      <h3>Availability</h3>

      @if (this.proofreaderError) {
        <div class="alert alert-danger">{{ this.proofreaderError }}</div>
      }

      <div class="">
        <div>Status:</div>
        <span
          class="badge text-bg-secondary"
          [class.text-bg-secondary]="this.proofreaderAvailability === 'downloadable'"
          [class.text-bg-danger]="this.proofreaderAvailability === 'unavailable'"
          [class.text-bg-success]="this.proofreaderAvailability === 'available'"
          [class.text-bg-primary]="this.proofreaderAvailability === 'downloading'">{{ this.proofreaderAvailability }}</span>
      </div>

      <div class="d-grid mt-5">
        <button class="btn btn-primary" (click)="checkProofreaderAvailability()">Check availability</button>
      </div>
    </div>
  </div>
  <div class="card flex-fill">
    <div class="card-body">
      <h3>Creation</h3>

      @if (this.proofreaderCreationError) {
        <div class="alert alert-danger">{{ this.proofreaderCreationError }}</div>
      }

      <div class="">
        <div>Status:</div>
        <span
          class="badge text-bg-secondary"
          [class.text-bg-secondary]="this.proofreaderCreationSuccess === undefined"
          [class.text-bg-danger]="this.proofreaderCreationSuccess === false"
          [class.text-bg-success]="this.proofreaderCreationSuccess === true">{{ this.proofreaderCreationSuccess }}</span>
      </div>

      <div class="d-grid mt-5">
        <button class="btn btn-primary" (click)="createProofreader()">Create</button>
      </div>
    </div>
  </div>
</div>

<hr>

<h2 class="mt-4 ms-2">Rewriter</h2>

<div class="d-flex gap-3">
  <div class="card flex-fill">
    <div class="card-body">
      <h3>Availability</h3>

      @if (this.rewriterError) {
        <div class="alert alert-danger">{{ this.rewriterError }}</div>
      }

      <div class="">
        <div>Status:</div>
        <span
          class="badge text-bg-secondary"
          [class.text-bg-secondary]="this.rewriterAvailability === 'downloadable'"
          [class.text-bg-danger]="this.rewriterAvailability === 'unavailable'"
          [class.text-bg-success]="this.rewriterAvailability === 'available'"
          [class.text-bg-primary]="this.rewriterAvailability === 'downloading'">{{ this.rewriterAvailability }}</span>
      </div>

      <div class="d-grid mt-5">
        <button class="btn btn-primary" (click)="checkRewriterAvailability()">Check availability</button>
      </div>
    </div>
  </div>
  <div class="card flex-fill">
    <div class="card-body">
      <h3>Creation</h3>

      @if (this.rewriterCreationError) {
        <div class="alert alert-danger">{{ this.rewriterCreationError }}</div>
      }

      <div class="">
        <div>Status:</div>
        <span
          class="badge text-bg-secondary"
          [class.text-bg-secondary]="this.rewriterCreationSuccess === undefined"
          [class.text-bg-danger]="this.rewriterCreationSuccess === false"
          [class.text-bg-success]="this.rewriterCreationSuccess === true">{{ this.rewriterCreationSuccess }}</span>
      </div>

      <div class="d-grid mt-5">
        <button class="btn btn-primary" (click)="createRewriter()">Create</button>
      </div>
    </div>
  </div>
</div>
<hr>

<h2 class="mt-4 ms-2">Summarizer</h2>

<div class="d-flex gap-3">
  <div class="card flex-fill">
    <div class="card-body">
      <h3>Availability</h3>

      @if (this.summarizerError) {
        <div class="alert alert-danger">{{ this.summarizerError }}</div>
      }

      <div class="">
        <div>Status:</div>
        <span
          class="badge text-bg-secondary"
          [class.text-bg-secondary]="this.summarizerAvailability === 'downloadable'"
          [class.text-bg-danger]="this.summarizerAvailability === 'unavailable'"
          [class.text-bg-success]="this.summarizerAvailability === 'available'"
          [class.text-bg-primary]="this.summarizerAvailability === 'downloading'">{{ this.summarizerAvailability }}</span>
      </div>

      <div class="d-grid mt-5">
        <button class="btn btn-primary" (click)="checkSummarizerAvailability()">Check availability</button>
      </div>
    </div>
  </div>
  <div class="card flex-fill">
    <div class="card-body">
      <h3>Creation</h3>

      @if (this.summarizerCreationError) {
        <div class="alert alert-danger">{{ this.summarizerCreationError }}</div>
      }

      <div class="">
        <div>Status:</div>
        <span
          class="badge text-bg-secondary"
          [class.text-bg-secondary]="this.summarizerCreationSuccess === undefined"
          [class.text-bg-danger]="this.summarizerCreationSuccess === false"
          [class.text-bg-success]="this.summarizerCreationSuccess === true">{{ this.summarizerCreationSuccess }}</span>
      </div>

      <div class="d-grid mt-5">
        <button class="btn btn-primary" (click)="createSummarizer()">Create</button>
      </div>
    </div>
  </div>
</div>


<hr>

<h2 class="mt-4 ms-2">Writer</h2>

<div class="d-flex gap-3">
  <div class="card flex-fill">
    <div class="card-body">
      <h3>Availability</h3>

      @if (this.writerError) {
        <div class="alert alert-danger">{{ this.writerError }}</div>
      }

      <div class="">
        <div>Status:</div>
        <span
          class="badge text-bg-secondary"
          [class.text-bg-secondary]="this.writerAvailability === 'downloadable'"
          [class.text-bg-danger]="this.writerAvailability === 'unavailable'"
          [class.text-bg-success]="this.writerAvailability === 'available'"
          [class.text-bg-primary]="this.writerAvailability === 'downloading'">{{ this.writerAvailability }}</span>
      </div>

      <div class="d-grid mt-5">
        <button class="btn btn-primary" (click)="checkWriterAvailability()">Check availability</button>
      </div>
    </div>
  </div>

  <div class="card flex-fill">
    <div class="card-body">
      <h3>Creation</h3>

      @if (this.writerCreationError) {
        <div class="alert alert-danger">{{ this.writerCreationError }}</div>
      }

      <div class="">
        <div>Status:</div>
        <span
          class="badge text-bg-secondary"
          [class.text-bg-secondary]="this.writerCreationSuccess === undefined"
          [class.text-bg-danger]="this.writerCreationSuccess === false"
          [class.text-bg-success]="this.writerCreationSuccess === true">{{ this.writerCreationSuccess }}</span>
      </div>

      <div class="d-grid mt-5">
        <button class="btn btn-primary" (click)="createWriter()">Create</button>
      </div>
    </div>
  </div>

</div>
